<p-dialog [header]="getHeader()" [visible]="visible" styleClass="w-[95vw] lg:w-[70vw] lg:max-w-[1000px]"
  [draggable]="false" [modal]="true" (onShow)="onShow()" (onHide)="onHide()" (visibleChange)="onVisibleChange($event)">
  <div class="">
    <div
      *ngIf="(bookingInspectionData && bookingInspectionData.bookInspectionRoomType && bookingInspectionData.bookInspectionRoom && roomTypeConfig) || !isNeedInspectionData">
      
      <div class="text-[18px] lg:text-[20px] font-medium text-black" *ngIf="bookingInspectionData">
        {{bookingInspectionData.bookInspectionRoomType?.roomTypeName}} - Apartment
        {{bookingInspectionData.bookInspectionRoom?.roomNumber}}
      </div>
      <div class="text-[18px] lg:text-[20px] font-medium text-black" *ngIf="!bookingInspectionData && !roomTypeConfig && currentStep == 'fillData'">
        {{getHotelSelectName()}}
      </div>
      <div [style]="{'display': currentStep == 'selectTime' ? 'block' : 'none'}">
        <div class="lg:grid lg:grid-cols-2 lg:gap-[56px] w-full">
          <div class="lg:flex justify-center items-start">
            <div class="mt-8 lg:mt-2 select-time w-full">
              <div class="w-full mb-4 lg:mb-6">
                <app-xn-form #systemTypeForm [fields]="systemFields" [submitted]="false"></app-xn-form>
              </div>
              <p-calendar 
                #calendar class="w-full" 
                [inline]="true" 
                [style]="{'width': '100%'}"
                [minDate]="getCurrentDate()" 
                (onMonthChange)="onMonthChange($event)" 
                [disabledDates]="disableDate"
                (onSelect)="onDateChange($event)" [(ngModel)]="selectDate">
                <!-- <ng-template pTemplate="date" let-date>
                  <div>
                    <div class="font-medium text-center">
                      {{date.day}}
                    </div>
                    <div class="text-center mt-1">
                      <span *ngFor="let icon of getIconForDate(date)" class="text-sm pointer-events-none">
                        <img [src]="getSrcIconImage(icon)" width="16px" height="16px" />
                      </span>
                    </div>
                  </div>
                </ng-template> -->
              </p-calendar>
            </div>
          </div>
          <div class="flex flex-col justify-between">
            <!-- <div *ngIf="!data.visitDate" class="mt-4 lg:mt-[92px]">
              <div class="mb-6 flex items-center">
                <img src="assets/images/morning.svg" width="24px" height="24px" class="mr-4" />
                <span class="text-2xl font-medium">Morning</span>
              </div>
              <div class="mb-6 flex items-center">
                <img src="assets/images/afternoon.svg" width="24px" height="24px" class="mr-4" />
                <span class="text-2xl font-medium">Afternoon</span>
              </div>
              <div class="mb-6 flex items-center">
                <img src="assets/images/evening.svg" width="24px" height="24px" class="mr-4" />
                <span class="text-2xl font-medium">Evening</span>
              </div>
            </div> -->
            <div *ngIf="data.visitDate">
              <div class="mt-[40px] lg:mt-4 mb-2 lg:mb-4 visit-date w-full flex justify-center items-center px-4 pt-0 text-[16px]">
                {{formatDate(data.visitDate)}}
              </div>
              <div *ngFor="let siteTour of timeSlotConfigures" class="mb-4">
                <!-- <div class="mb-2 font-semibold text-lg" *ngIf="timeSlotConfigures?.length > 1 && (getAvailableTime(siteTour.code, 'morning').length || getAvailableTime(siteTour.code, 'afternoon').length || getAvailableTime(siteTour.code, 'evening').length)">
                  {{siteTour.name}}
                </div> -->
                <div>
                  <div>
                    <!-- <div class="flex items-center">
                      <img src="assets/images/morning.svg" width="24px" height="24px" class="mr-4" />
                      <span class="text-md font-medium">Morning</span>
                    </div> -->
                    <div>
                      <div class="mt-2 time-box inline-block mr-3"
                        *ngFor="let time of getAvailableTime(siteTour.code, 'morning')"
                        [class.active]="data.timeSelect == time" (click)="selectTime(time, siteTour)">
                        {{time.description}}
                      </div>
                      <div class="mt-2 time-box inline-block mr-3"
                        *ngFor="let time of getAvailableTime(siteTour.code, 'afternoon')"
                        [class.active]="data.timeSelect == time" (click)="selectTime(time, siteTour)">
                        {{time.description}}
                      </div>
                      <div class="mt-2 time-box inline-block mr-3"
                        *ngFor="let time of getAvailableTime(siteTour.code, 'evening')"
                        [class.active]="data.timeSelect == time" (click)="selectTime(time, siteTour)">
                        {{time.description}}
                      </div>
                    </div>
                    <div class="mt-8">
                      <div class="text-[12px] md:text-[16px] font-medium">About the tour</div>
                      <div class="text-[12px] md:text-[16px] mt-4" [innerHTML]="systemTypeDescription">
                      </div>
                      <div class="text-[12px] md:text-[16px] mt-4" *ngIf="!systemTypeDescription">
                        Please allow 45 minutes for us to show you around the apartments and amenities.
                        If you’re keen to move quickly on applying for an apartment, have your ID, passport, employer and rental history with you.  <br/><br/> 
                      </div>
                    </div>
                  </div>
                  <!-- <div *ngIf="getAvailableTime(siteTour.code, 'afternoon').length" class="mb-3">
                    <div class="flex items-center">
                      <img src="assets/images/afternoon.svg" width="24px" height="24px" class="mr-4" />
                      <span class="text-md font-medium">Afternoon</span>
                    </div>
                    <div>

                      <div class="mt-2 time-box inline-block mr-3"
                        *ngFor="let time of getAvailableTime(siteTour.code, 'afternoon')"
                        [class.active]="data.timeSelect == time" (click)="selectTime(time, siteTour)">
                        {{time.description}}
                      </div>
                    </div>
                  </div> -->
                  <!-- <div *ngIf="getAvailableTime(siteTour.code, 'evening').length" class="mb-3">
                    <div class="flex items-center">
                      <img src="assets/images/evening.svg" width="24px" height="24px" class="mr-4" />
                      <span class="text-md font-medium">Evening</span>
                    </div>
                    <div>
                      <div class="mt-2 time-box inline-block mr-3"
                        *ngFor="let time of getAvailableTime(siteTour.code, 'evening')"
                        [class.active]="data.timeSelect == time" (click)="selectTime(time, siteTour)">
                        {{time.description}}
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div *ngIf="data.visitDate">
              <div class="lg:float-right">
                <button [disabled]="data.timeSelect ? false : true" class="btn btn-primary w-full lg:w-[160px] mt-4"
                  (click)="nextStep()">Next</button>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div [style]="{'display': (currentStep == 'fillData' && data.timeSelect) ? 'block' : 'none'}">
        <div class="mt-4 text text-[16px] lg:text-[18px] text-black font-medium" *ngIf="roomTypeConfig?.propertyName && bookingInspectionData?.bookInspectionRoom?.roomNumber">{{roomTypeConfig?.propertyName}} Tour for Apt
          {{bookingInspectionData?.bookInspectionRoom?.roomNumber}} at {{getDescriptionTimeSelect(data.timeSelect)}} of
          {{formatDate(data.visitDate || '')}}
        </div>

        <div class="mt-4 text-[16px] lg:text-[18px] text-black font-medium" *ngIf="!roomTypeConfig && !bookingInspectionData">
          Tour at {{getDescriptionTimeSelect(data.timeSelect)}} of {{formatDate(data.visitDate || '')}}
        </div>
        <!-- <div class="mt-4 text-black">Help us tailor this tour for you by providing as much info as possible</div> -->
        <div class="mt-4"><app-xn-form #inspectForm [fields]="fields" [submitted]="isSubmitted"></app-xn-form></div>
        <div class="mt-8 text-right flex justify-between">
          <button class="btn btn-secondary w-[68px] lg:w-[100px]" (click)="previousStep()">Back</button>
          <button class="btn btn-primary" [disabled]="!checkValid()" (click)="submit()">Submit</button>
        </div>
      </div>

    </div>
  </div>
</p-dialog>